<template>
  <div class="row">
    <div v-if="menuItemData.type === 'pages'">
      Original:
      <a
        v-if="menuItemData.data"
        :href="slugParser(menuItemData.data.value)"
        target="_blank"
        >{{ menuItemData.data.label }}</a
      >
    </div>
    <div class="col-12 col-sm-3">
      <small>Name</small>
      <el-input
        v-model="menuItemData.name"
        type="text"
        required
        placeholder="Name"
      ></el-input>
    </div>
    <div class="col-12 col-sm-3 d-flex">
      <small>Type <span style="color: red">*</span></small>
      <el-select v-model="menuItemData.type" placeholder="Select">
        <el-option-group
          v-for="group in options"
          :key="group.id"
          :label="group.type"
          :value="group.label"
        >
          <el-option
            v-for="item in group.options"
            :key="item.label"
            :label="item.value"
            :value="item.label"
          />
        </el-option-group>
      </el-select>
    </div>
    <div v-if="menuItemData.type" class="col-12 col-sm-3 d-flex">
      <small>Link <span style="color: red">*</span></small>
      <div v-if="menuItemData.type === 'external'">
        <el-input
          v-model="menuItemData.externalLink"
          type="text"
          required
          placeholder="Link"
        ></el-input>
      </div>
      <div v-else>
        <el-select
          v-model="menuItemData.data"
          filterable
          remote
          placeholder="Please enter a keyword"
          :remote-method="remoteMethod"
          :loading="loading"
          value-key="id"
        >
          <el-option
            v-for="item in data"
            :key="item.value"
            :label="item.label"
            :value="item"
          />
        </el-select>
      </div>
    </div>
    <div v-if="menuItemData.type" class="col-12 col-sm-3 d-flex">
      <small>Target?</small>
      <el-checkbox
        v-model="menuItemData.blankTarget"
        label="Open in new tab?"
        size="small"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuItem: Object,
  },
  data() {
    return {
      menuItemData: {
        name: "",
        type: "",
        data: {},
        blankTarget: false,
        externalLink: "",
      },
      loading: false,
      query: "",
      data: [],
      options: [
        {
          id: 0,
          type: "Pages",
          label: "pages",
          options: [
            {
              value: "Pages",
              label: "pages",
            },
          ],
        },
        {
          id: 4,
          type: "Category + Tags (filter)",
          label: "filter",
          options: [
            {
              value: "Collector Items",
              label: "collector-items",
            },
            {
              value: "Colors",
              label: "colors",
            },
            {
              value: "Types",
              label: "types",
            },
            {
              value: "Suites",
              label: "suits",
            },
            {
              value: "Tags",
              label: "tags",
            },
          ],
        },
        {
          id: 5,
          type: "External",
          label: "external",
          options: [
            {
              value: "External",
              label: "external",
            },
          ],
        },
        {
          id: 6,
          type: "Artworks",
          label: "artworks",
          options: [
            {
              value: "Artworks",
              label: "artworks",
            },
          ],
        },
        {
          id: 7,
          type: "Artists",
          label: "artists",
          options: [
            {
              value: "Artists",
              label: "artists",
            },
          ],
        },
        {
          id: 8,
          type: "Techniques",
          label: "techniques",
          options: [
            {
              value: "Techniques",
              label: "techniques",
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.menuItemData = { ...this.menuItem };

    if (this.menuItemData.created_at) {
      if (this.menuItemData.item_properties[0]) {
        this.menuItemData.data =
          this.menuItemData.item_properties[0].data || {};
        this.data = [this.menuItemData.item_properties[0].data] || [];
        this.menuItemData.externalLink =
          this.menuItemData.item_properties[0].externalLink || "";
        this.menuItemData.blankTarget =
          this.menuItemData.item_properties[0].blankTarget || false;
      }
    }
  },
  methods: {
    remoteMethod: function (query) {
      if (query) {
        this.loading = true;
        this.data = [];
        let fetchEndpoint = this.menuItemData.type;
        if (fetchEndpoint == "pages") {
          fetchEndpoint = "page-translations";
        }
        this.$api
          .get(
            `${
              process.env.VUE_APP_SHARED_API
            }api/${fetchEndpoint}?search=${query.toLowerCase()}`
          )
          .then((res) => {
            if (res.data.data) {
              res.data.data.map((item) => {
                this.data.push({
                  id: item.id,
                  label: item.name || item.title,
                  value: item,
                });
              });
              this.loading = false;
            } else {
              this.loading = false;
            }
          });
      } else {
        this.data = [];
      }
    },
    slugParser(item) {
      if (item?.page?.location == "frontpage") {
        return process.env.VUE_APP_FRONT_PREVIEW;
      } else if (item?.page?.location == "archive-techniques") {
        return process.env.VUE_APP_FRONT_PREVIEW + "techniques";
      } else if (item?.page?.location == "archive-artists") {
        return process.env.VUE_APP_FRONT_PREVIEW + "artist";
      } else if (item?.slug) {
        if (item?.quantity) {
          return process.env.VUE_APP_FRONT_PREVIEW + "artworks/" + item.slug;
        } else if (item?.biography) {
          return process.env.VUE_APP_FRONT_PREVIEW + "artist/" + item.slug;
        } else if (item?.principles) {
          return process.env.VUE_APP_FRONT_PREVIEW + "techniques/" + item.slug;
        } else {
          return process.env.VUE_APP_FRONT_PREVIEW + "pages/" + item.slug;
        }
      } else {
        return "#";
      }
    },
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "COLLECT_MENU_DATA") {
        this.$emit("collectData", this.menuItemData);
      }
    });
  },
  beforeUnmount() {
    this.unsubscribe();
  },
  watch: {
    "menuItemData.type"(oldV, newV) {
      if (newV) {
        this.menuItemData.data = {};
        this.menuItemData.externalLink = "";
        this.data = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.d-flex {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
}
</style>
